import * as categoryActions from '../actions/category.actions';
import {Branch} from '../models/Branch';

export interface ICategoryState  {
  categories: Branch[];
  loading: boolean;
}

export const inittialCategoryState: ICategoryState = {  
  categories: [],
  loading: false
};

export function reducer(productState: ICategoryState  = inittialCategoryState,
                        action: categoryActions.CategoryAction): ICategoryState  {

  switch (action.type) {

    case categoryActions.LOAD_CATEGORIES: {
      return {
        ...productState,
        loading: true
      };
    }

    case categoryActions.FETCH_CATEGORIES_FAILED: {
      return {
        ...productState,
        loading: false
      };
    }

    case categoryActions.LOAD_CATEGORIES_SUCCESS : {
      return {
        categories: action.payload,
        loading: false
      };
    }

    default : {
      return productState;
    }

  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/reducers/category.reducer.ts